import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { connect } from 'redaction'
import Media from 'sb-media'
import { compose, constants } from 'common/helpers'
import { FormattedHTMLMessage, FormattedMessage } from 'sb-react-intl'

import Modal from 'components/modal/Modal/Modal'
import Product from 'components/product/Product/Product'
import CommonButton from 'components/buttons/CommonButton/CommonButton'
import ContentLoaderAwareOfRequestLoader from 'components/loaders/ContentLoaderAwareOfRequestLoader/ContentLoaderAwareOfRequestLoader'

import messages from './messages'
import s from './NoteRecommendationsModal.scss'


class NoteRecommendationsModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.shape({
      placement: PropTypes.string.isRequired, // addTo: queue or cart
      note: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
      }).isRequired,
    }),
    selectedProductId: PropTypes.number,
    isFetching: PropTypes.bool,
    products: PropTypes.array,
  }

  static defaultProps = {
    name: constants.modals.NoteRecommendations,
  }

  componentDidMount() {
    const { selectedProductId, data: { note } } = this.props

    actions.view.noteRecommendationsModal.fetch({
      noteId: note.id,
      limit: 6,
      excludeProductId: selectedProductId,
    })
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  render() {
    const { name, data: { placement, note }, products, isFetching } = this.props

    const titleNode = (
      <FormattedHTMLMessage tag="div" className={s.title} {...messages.title} values={{ note: note.name.toLowerCase() }} />
    )

    const metadata          = { placement: 'note popup' }
    const snowplowMetadata  = { placement: 'note recommendations modal' } // TODO SNOWPLOW check if correct

    let content

    if (isFetching) {
      content = (
        <ContentLoaderAwareOfRequestLoader />
      )
    }
    else if (!products.length) {
      content = (
        <FormattedMessage className={s.empty} tag="div" {...messages.empty} />
      )
    }
    else {
      content = (
        <div className={s.items}>
          {
            products
              .map((item) => (
                <div key={item.id} className={s.item} onClick={this.close}>
                  <Product
                    containerClassName={s.product}
                    data={item}
                    addTo={placement}
                    metadata={metadata}
                    snowplowMetadata={snowplowMetadata}
                    isQuickViewVisible
                    onQuickViewClick={this.close}
                  />
                </div>
              ))
          }
        </div>
      )
    }

    return (
      <Modal
        className={s.modal}
        name={name}
        titleNode={titleNode}
        onClose={this.close}
      >
        {content}
        <Media mobile>
          <CommonButton styleName="button" close fullWidth onClick={this.close} />
        </Media>
      </Modal>
    )
  }
}


export default compose(
  connect({
    selectedProductId: 'view.productPage.id',
    isFetching: 'view.noteRecommendationsModal.isFetching',
    products: 'view.noteRecommendationsModal.products',
  }),
)(NoteRecommendationsModal)
